<template>
  <div
    :class="{
      'mobile-float': isMobile,
      'mobile-float-full-height': isFullScreen,
    }"
  >
    <side-bar
      :right="right"
      :show.sync="c_show"
      disabled-expand
      :class="{ 'full-height full-width': isMobile }"
      class="draggable-float"
      :width="width"
      :style="c_style"
    >
      <v-card
        class="full-width full-height d-flex flex-column overflow-hidden"
        flat
        tile
        :max-height="maxHeight"
      >
        <v-toolbar
          class="flex-grow-0"
          color="lighten-2 pr-3"
          dense
          flat
          height="40px"
          short
          v-if="!disabledHeader && headerLocation === 'top'"
        >
          <v-toolbar-title>
            <slot name="title"></slot>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <slot name="extra-btn"></slot>
          <v-btn
            v-if="!disabledOrder && count > 1"
            icon
            small
            @click="onToBack()"
          >
            <v-icon small>mdi-arrange-send-backward</v-icon>
          </v-btn>
          <v-btn icon small @click="onToggleExpand()" v-if="!isMobile">
            <v-icon small>{{
              !c_expand
                ? 'mdi-arrow-up-drop-circle-outline'
                : 'mdi-arrow-down-drop-circle-outline'
            }}</v-icon>
          </v-btn>
          <v-btn icon small @click="toggleFullScreen()" v-else>
            <v-icon small>{{
              !isFullScreen
                ? 'mdi-arrow-up-drop-circle-outline'
                : 'mdi-arrow-down-drop-circle-outline'
            }}</v-icon>
          </v-btn>
          <v-btn icon small @click="onClose()" v-if="!disabledClose">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider
          v-if="!disabledHeader && headerLocation === 'top'"
        ></v-divider>
        <div
          class="flex-grow-1 overflow-auto draggable-float-container"
          v-show="c_expand"
          v-if="isFullScreen"
        >
          <slot></slot>
        </div>

        <v-divider
          v-if="!disabledHeader && headerLocation === 'bottom'"
        ></v-divider>
        <v-toolbar
          class="flex-grow-0"
          color="lighten-2 pr-3"
          dense
          flat
          height="40px"
          short
          v-if="!disabledHeader && headerLocation === 'bottom'"
        >
          <v-toolbar-title style="width: 100%">
            <slot name="title"></slot>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <slot name="extra-btn"></slot>
          <v-btn
            v-if="!disabledOrder && count > 1"
            icon
            small
            @click="onToBack()"
          >
            <v-icon small>mdi-arrange-send-backward</v-icon>
          </v-btn>
          <v-btn icon small @click="onToggleExpand()" v-if="!isMobile">
            <v-icon small>{{
              !c_expand
                ? 'mdi-arrow-up-drop-circle-outline'
                : 'mdi-arrow-down-drop-circle-outline'
            }}</v-icon>
          </v-btn>
          <v-btn icon small @click="toggleFullScreen()" v-else>
            <v-icon small>{{
              !isFullScreen
                ? 'mdi-arrow-up-drop-circle-outline'
                : 'mdi-arrow-down-drop-circle-outline'
            }}</v-icon>
          </v-btn>
          <v-btn icon small @click="onClose()" v-if="!disabledClose">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </side-bar>
  </div>
</template>

<script>
import SideBar from '@components/sidebar/map-sidebar.vue'
import { getUUIDv4 } from '@utils'
export default {
  components: { SideBar },
  props: {
    id: { type: String, requred: true },
    show: Boolean,
    title: {
      type: String,
      default: '',
    },
    prefix: { type: String, default: 'mapbox' },
    disabledClose: Boolean,
    disabledHeader: Boolean,
    disabledOrder: Boolean,
    width: { type: [String, Number], default: 'auto' },
    top: { type: Number, default: undefined },
    left: { type: Number, default: undefined },
    bottom: { type: Number, default: undefined },
    right: { type: Number, default: undefined },
    headerLocation: {
      type: String,
      default: 'bottom',
      validator: function(value) {
        // The value must match one of these strings
        return ['top', 'bottom'].includes(value)
      },
    },
  },
  inject: {
    registerSidebar: { default: () => {} },
    registerSidebarShow: { default: () => {} },
    unRegisterSidebar: { default: () => {} },
    setSidebarToBack: { default: () => {} },
  },
  data: () => ({
    id_sidebar: '',
    p_zIndex: 0,
    p_show: false,
    is_first: false,
    count: 0,
    isFullScreen: true,
    p_expand: true,
    maxHeight: 500,
  }),
  mounted() {
    this.id_sidebar = `popup-${getUUIDv4()}`
    this.registerSidebar(this.id_sidebar, {
      setIndex: this.onSetIndex.bind(this),
      getTitle: this.getTitle,
      right: this.right,
    })
    this.c_show = this.show
    if (!this.isMobile) {
      this.$nextTick(() => {
        this.onResize()
        window.addEventListener('resize', this.onResize)
      })
      window.addEventListener('resize', this.onResize)
    }
  },
  beforeDestroy() {
    this.unRegisterSidebar(this.id_sidebar)
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    show: {
      handler(val) {
        this.c_show = val
      },
    },
  },
  computed: {
    c_expand: {
      get() {
        return this.p_expand
      },
      set(value) {
        this.p_expand = value
        this.$emit('update:expand', value)
      },
    },
    c_style() {
      let style = {}
      style.zIndex = this.p_zIndex
      if (this.isMobile) return style
      if (this.top) {
        style.top = this.top + 'px'
      }
      if (this.left) {
        style.left = this.left + 'px'
      }
      if (this.right) {
        style.right = this.right + 'px'
      }
      if (this.bottom) {
        style.bottom = this.bottom + 'px'
      }
      if (this.width && this.width != 'auto') {
        if (!isNaN(this.width)) style.width = this.width + 'px'
        else {
          style.width = this.width
        }
      }
      return style
    },
    c_show: {
      get() {
        return this.p_show
      },
      set(val) {
        this.p_show = val
        this.$emit('update:show', val)
        if (!val) {
          this.checkAndEmit('close')
        }
        this.registerSidebarShow(this.id_sidebar, val)
      },
    },
  },
  methods: {
    onResize() {
      let height_container = this.$el.parentElement.parentElement.clientHeight
      if (height_container < 300) {
        this.maxHeight = '100%'
      } else if (height_container < 600) {
        this.maxHeight = height_container / 2
      } else {
        this.maxHeight = 500
      }
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    onSetIndex(index, { is_first, count }) {
      this.p_zIndex = index
      this.is_first = is_first
      this.count = count
    },
    getTitle() {
      return this.title
    },
    onClose() {
      this.c_show = false
    },
    onToBack() {
      this.setSidebarToBack(this.id_sidebar)
    },
    onToggleExpand() {
      this.c_expand = !this.c_expand
    },
  },
}
</script>

<style>
.draggable-float.sidebar-container {
  border-right: none;
  top: unset;
  left: unset;
}
</style>

<style scoped>
.mobile-float {
  height: 40px;
  width: 100%;
  position: absolute;
  bottom: 0 !important;
  left: 0 !important;
}

.mobile-float.mobile-float-full-height {
  height: 50%;
}
</style>
